import { Injectable } from '@angular/core';
import { ApiService } from '@us/web/shared/data-access';
import { map, Observable } from 'rxjs';
import { Table } from '@us/web/shared/data-access';
import { Area } from '@us/web/shared/data-access';

@Injectable({
    providedIn: 'root'
})
export class AreasService {
    constructor(private apiService: ApiService) {}

    public getAreas(): Observable<Area[]> {
        return this.apiService.get('shop/tables').pipe(
            map((areas: Area[]) =>
                areas.map(area => ({
                    ...area,
                    tables: area.tables.map((table: Table) => ({
                        ...table,
                        area_id: area.id,
                        area_name: area.name
                    }))
                }))
            )
        );
    }
}
